import React from 'react'
import { keyBy } from 'lodash'
import { graphql, useFragment } from 'react-relay/hooks'
import { FlexRow } from 'elements'
import AnomaliesCard from './cards/AnomaliesCard'
import TextCard from './cards/TextCard'
import { FormattedNumber } from 'react-intl'

type Props = { organization: any }

export default function OrganizationDashboard(props: Props) {
  const { organization } = props

  const data = useFragment(
    graphql`
      fragment OrganizationDashboard_organization on Organization {
        reportMetrics {
          name
          value
        }
        totalCompanies: companies(includeDeleted: NO) {
          totalCount
        }
      }
    `,
    organization,
  )

  if (!data?.reportMetrics?.length) {
    return null
  }

  const { reportMetrics, totalCompanies } = data

  const keyedMetrics = keyBy(reportMetrics, 'name')

  return (
    <FlexRow justifyContent="space-around" pt="xlarge" pb="xxxlarge">
      <TextCard
        value={<FormattedNumber value={totalCompanies.totalCount} />}
        text={totalCompanies.totalCount === 1 ? 'Client' : 'Clients'}
      />
      <AnomaliesCard
        anomalyCountHigh={keyedMetrics.anomalyCountHigh.value}
        anomalyCountMedium={keyedMetrics.anomalyCountMedium.value}
        anomalyCountLow={keyedMetrics.anomalyCountLow.value}
      />
      <TextCard
        value={<FormattedNumber value={keyedMetrics.transactionCount.value} />}
        text="Total transactions"
      />
    </FlexRow>
  )
}
